import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./index.css";

// Importar fonte Poppins se ainda não estiver
if (typeof document !== 'undefined') {
  const link = document.createElement('link');
  link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap';
  link.rel = 'stylesheet';
  if (!document.head.querySelector('link[href*="Poppins"]')) {
    document.head.appendChild(link);
  }
}

export function QueueHeader() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const location = useLocation();

  // Verificar se está na página de consulta (QueueFind)
  // A URL é no formato /{pluginspace_id}/queue/{phone}
  const pathParts = location.pathname.split('/').filter(part => part !== '');
  const queueIndex = pathParts.findIndex(part => part === 'queue');
  const isQueueFindPage = queueIndex !== -1 && pathParts.length > queueIndex + 1 && pathParts[queueIndex + 1].match(/^\d+$/);

  const handleButtonClick = () => {
    if (isQueueFindPage) {
      // Se está na página QueueFind, volta para entrar na fila
      navigate(`/${pluginspace_id}/queue`);
    } else {
      // Se está na página de entrada, não faz nada (ou pode implementar outra ação)
      // Como não há uma página de "consulta" separada, o botão fica oculto ou desabilitado
      return;
    }
  };

  return (
    <header 
      style={{
        background: "linear-gradient(135deg, rgba(33, 150, 243, 0.08) 0%, rgba(30, 136, 229, 0.05) 50%, rgba(25, 118, 210, 0.06) 100%)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(33, 150, 243, 0.2)",
        boxShadow: "0 4px 24px rgba(33, 150, 243, 0.12)",
        position: "sticky" as const,
        top: 0,
        zIndex: 1000,
        width: "100%"
      }}
    >
      <div style={{
        margin: "0",
        padding: "16px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start"
      }}>
        {/* Logo e Nome - Esquerda */}
        <div 
          onClick={() => navigate(`/${pluginspace_id}/queue`)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            marginRight: "16px"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.02)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          {/* Ícone com gradiente */}
          <div style={{
            position: "relative" as const,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(135deg, #4377FF 0%, #8b5cf6 100%)",
              borderRadius: "16px",
              filter: "blur(12px)",
              opacity: 0.4
            }} />
            <div style={{
              position: "relative",
              padding: "10px",
              borderRadius: "16px",
              background: "linear-gradient(135deg, #4377FF 0%, #8b5cf6 100%)",
              boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)"
            }}>
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: "block" }}
              >
                {/* Círculo do relógio */}
                <circle 
                  cx="12" 
                  cy="12" 
                  r="9" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                {/* Ponteiro das horas (apontando para 10) */}
                <path 
                  d="M12 12L9.5 8.5" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                {/* Ponteiro dos minutos (apontando para 2) */}
                <path 
                  d="M12 12L14.5 8" 
                  stroke="white" 
                  strokeWidth="1.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                {/* Centro do relógio */}
                <circle 
                  cx="12" 
                  cy="12" 
                  r="1.5" 
                  fill="white"
                />
              </svg>
            </div>
          </div>

          {/* Nome */}
          <div>
            <h1 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "24px",
              fontWeight: "700",
              color: "#2d3436",
              letterSpacing: "-0.5px",
              lineHeight: 1,
              margin: 0
            }}>
              Fila<span style={{
                background: "linear-gradient(135deg, #4377FF 0%, #8b5cf6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}>Fácil</span>
            </h1>
          </div>
        </div>

        {/* Botão Voltar - Direita (só aparece no QueueFind) */}
        {isQueueFindPage && (
          <button
            onClick={handleButtonClick}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(33, 150, 243, 0.3)";
              e.currentTarget.style.background = "linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(30, 136, 229, 0.1) 100%)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(33, 150, 243, 0.15)";
              e.currentTarget.style.background = "transparent";
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "6px 12px",
              background: "transparent",
              border: "1px solid rgba(33, 150, 243, 0.3)",
              borderRadius: "8px",
              color: "#4377FF",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 2px 8px rgba(33, 150, 243, 0.15)",
              outline: "none",
              marginLeft: "auto",
              marginRight: "20px"
            }}
          >
            {/* Ícone de Voltar (seta para esquerda) */}
            <svg 
              width="14" 
              height="14" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              style={{ display: "block" }}
            >
              <path 
                d="M19 12H5M5 12L12 19M5 12L12 5" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            Voltar para Fila
          </button>
        )}
      </div>
    </header>
  );
}
